import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ModalOpenContextValue = {
  isModalOpen: boolean;
  registerModalOpen: () => () => void;
};

const ModalOpenContext = createContext<ModalOpenContextValue | null>(null);

export const ModalOpenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openCount, setOpenCount] = useState(0);

  const registerModalOpen = useCallback(() => {
    setOpenCount((c) => c + 1);
    return () => setOpenCount((c) => Math.max(0, c - 1));
  }, []);

  const value = useMemo(
    () => ({
      isModalOpen: openCount > 0,
      registerModalOpen,
    }),
    [openCount, registerModalOpen],
  );

  return <ModalOpenContext.Provider value={value}>{children}</ModalOpenContext.Provider>;
};

export const useModalOpen = (): ModalOpenContextValue => {
  const ctx = useContext(ModalOpenContext);
  if (!ctx) {
    return {
      isModalOpen: false,
      registerModalOpen: () => () => undefined,
    };
  }
  return ctx;
};
